module.exports = __webpack_public_path__ + "img/chickensigara-t.fd9b65d4.gif";